
































































import { Component, Mixins } from 'vue-property-decorator';
import { LocalProductItem, ProductItem } from 'src/types/views/home';
import InitData from 'src/mixin/initDataWithoutQuery';
import { CommonRes } from 'src/types/views/common';
import { delProduct } from 'service/api';
import { PopoverComponent } from 'src/types/components/popover';

@Component
export default class MyProduct extends Mixins(InitData) {
  data: LocalProductItem[] = [];

  url = 'product/findAll';

  pageSize = 20;

  beforeInit() {
    this.params = {
      pageNum: this.pageNum,
      pageSize: this.pageSize,
    };
    return true;
  }

  async delItem(id: string) {
    this.loading = true;
    const res = await delProduct(id);
    if ((res as {state: boolean}).state) {
      this.loading = false;
      (this.$refs[`del_${id}`] as PopoverComponent[])[0].doClose();
      this.$message.success('删除成功');
      this.delChangePage();
      this.init();
    }
  }

  edit(id: string) {
    this.$router.push({ name: 'product', query: { id } });
  }

  afterInit(res: CommonRes<ProductItem>) {
    this.data = res.data.rows.map((item) => {
      const productType = item.productType !== '0'
        ? item.producttypename.replace(/[(（].*?[)）]/g, '')
        : '综合';
      const subTypeName = item.producttypename.match(/[(（].*?[)）]/g);
      const subProductType = subTypeName
        ? subTypeName
          .map((name: string) => name.replace(/[()（）]/g, '').split('，'))
          .reduce((prev: string[], cur: string[]) => prev.concat(cur), [])
          .sort((a: string, b: string) => a.length - b.length)
        : ['全部'];
      return {
        name: item.name,
        type: productType,
        subType: subProductType.length > 4 ? subProductType.slice(0, 3).concat('...') : subProductType,
        area: item.serviceareaname,
        id: item.id,
        time: item.createTime.substr(0, 10),
      };
    });
    this.total = res.data.count || 0;
    return true;
  }

  activated() {
    if (this.$store.state.shouldRefresh) {
      this.init();
      this.$store.commit('SET_REFRESH', false);
    }
  }

  toDetail(name: string, id: string) {
    this.$router.push({
      name,
      query: { id },
    });
  }
}
